import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useUserLocation } from '~/context/common/UserContext';
import LocationContext from '~/context/vdp/LocationContext';
import { fetchDeliveryContext } from '~/services/vdp';
import generateErrorLogger from '~/utilities/errorHandlers';

function useGetDeliveryContext() {
  const {
    deliveryContext: { setData, setError, setLoading }
  } = useContext(LocationContext);
  const { zip } = useUserLocation();

  useEffectWithController(
    controller => {
      if (!zip) return;

      setLoading();

      fetchDeliveryContext({ zip }, controller)
        .then(({ data }) => setData(data))
        .catch(
          generateErrorLogger(
            'Get delivery context',
            {},
            { callback: setError }
          )
        );
    },
    [setData, setError, setLoading, zip]
  );
}

export default useGetDeliveryContext;
